import queryString from 'query-string'
import { push } from "../../helpers/navigation/navigationService";
import { createNotification } from 'react-redux-notify'
import { select, put, takeLatest, all } from 'redux-saga/effects'

import api from '../../Environment'
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage'
import { setFilterCount, fetchSearchUserError, fetchSearchUserSuccess } from '../actions/SearchAction'
import { APPLY_FILTER, FETCH_SEARCH_USER_START, SET_FILTER_VALUES, SET_SEARCH_KEY } from '../actions/ActionConstant'
import { showErrorComponent } from '../actions/ComponentAction'

function* handleFilter() {
  const searchValues = yield select((state) => state.search.filters.filterValues);
  let count = 0;
  if (searchValues.max_age && searchValues.min_age) {
    count++;
  }
  if (searchValues.max_height && searchValues.min_height) {
    count++;
  }
  if (searchValues.max_credit_score && searchValues.min_credit_score) {
    count++;
  }
  for (let key in searchValues) {
    if (key !== "key" && key !== "max_age" && key !== "min_age" && 
       key !== "max_height" && key !== "min_height" &&
       key !== "max_credit_score" && key !== "min_credit_score" && searchValues[key]) {
      count++;
    }
  }

  yield put(setFilterCount(count));
}

function* handleQuerySearch() {
  const search = yield select((state) => state.search.filters)
  const payload = { ...search.filterValues, key: search.key }

  // if (search.key || search.filterCount > 0) {
    const query = yield queryString.stringify(payload)
    const searchQuery = `/search?${query}`
    yield push(searchQuery)
  // }
}

function* fetchSearchUserAPI() {
  try {
    const inputData = yield select((state) => state.search.users.inputData)
    const size = yield select((state) => state.search.users.size)
    const response = yield api.postMethod('users_filter', {
      ...inputData,
      per_page: size
    })
    if (response.data.success) {
      yield put(fetchSearchUserSuccess(response.data.data))
    } else {
      yield put(fetchSearchUserError(response.data.error))
      yield put(createNotification(getErrorNotificationMessage(response.data.error)))
    }
  } catch (error) {
    yield put(fetchSearchUserError(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(SET_FILTER_VALUES, handleFilter)])
  yield all([yield takeLatest(APPLY_FILTER, handleQuerySearch)])
  yield all([yield takeLatest(SET_SEARCH_KEY, handleQuerySearch)])
  yield all([yield takeLatest(FETCH_SEARCH_USER_START, fetchSearchUserAPI)])
}
